import { hashTestIdValue } from '../../../../../interactions/hashTestIdValue';
import { TagTestIdFactory } from '../../../Tag/interactions';
export const TagInputTestIdFactory = {
    // bases, you can use these for regex matching in playwright
    getTagInputBase: () => 'tag-input',
    getTagInputLabelBase: () => [TagInputTestIdFactory.getTagInputBase(), 'label'].join('-'),
    getTagInputDescriptionBase: () => [TagInputTestIdFactory.getTagInputBase(), 'description'].join('-'),
    getTagInputInputBase: () => [TagInputTestIdFactory.getTagInputBase(), 'input'].join('-'),
    // for test id generation
    getTagInputContainerTestId: (testId) => [TagInputTestIdFactory.getTagInputBase(), testId].join('-'),
    getTagInputLabelTestId: (testId) => [TagInputTestIdFactory.getTagInputLabelBase(), testId].join('-'),
    getTagInputDescriptionTestId: (testId) => [TagInputTestIdFactory.getTagInputDescriptionBase(), testId].join('-'),
    getTagInputInputTestId: (testId) => [TagInputTestIdFactory.getTagInputInputBase(), testId].join('-'),
    getTagInputTagTestId: (testId, tagValue) => TagTestIdFactory.getTagTestId(TagInputTestIdFactory.internalGenerateTagTestId(testId, tagValue)),
    getTagInputTagCloseButtonTestId: (testId, tagValue) => TagTestIdFactory.getTagCloseButtonTestId(TagInputTestIdFactory.internalGenerateTagTestId(testId, tagValue)),
    // internal, don't use outside of component
    internalGenerateTagTestId: (testId, tagValue) => [testId, hashTestIdValue(tagValue)].join('-'),
};
